import mutationsTypes from '@/vuex/caixa-postal/mutations-types.js'
const types = {
  ...mutationsTypes,
  INICIALIZAR_FORMULARIO_CAIXA_POSTAL: 'INICIALIZAR_FORMULARIO_CAIXA_POSTAL',
  GET_LISTA_UNIDADES_PROCEDENCIA_AUTORIZADAS: 'GET_LISTA_UNIDADES_PROCEDENCIA_AUTORIZADAS',
  GET_LISTA_TIPOS_DOCUMENTOS: 'GET_LISTA_TIPOS_DOCUMENTOS',
  GET_DOCUMENTO_CAIXA_POSTAL: 'GET_DOCUMENTO_CAIXA_POSTAL',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS',
  GET_ULTIMA_TRAMITACAO: 'GET_ULTIMA_TRAMITACAO'
}

export default types
